export default [
  {
    path: '/tax_web/risk_management',
    name: 'risk_management',
    component: { render: (e) => e('router-view') },
    children: [
      {
        path: 'risk_rule',
        name: 'risk_rule',
        component: () => import('../views/risk_management/risk_rule'),
        meta: { title: '风控规则' },
      },
    ],
    meta: { title: '风控管理' },
  },
];
